export const hasApplication = (
  applicationsHaystack: any[],
  applicationUUID: string
): boolean => {
  return applicationsHaystack.some(
    (application: any) => application === applicationUUID
  );
};
